import * as accountActions from 'redux/actions/account.actions'
import * as actions from 'redux/actions/users.actions'

const initialState = {
  saving: false,
  modalOpen: false,
  users: [],
  errors: null
}

const usersReducer = (state = initialState, { type, payload = {} }) => {
  switch (type) {
    case actions.getUsersSuccess.type:
      return {
        ...state,
        users: payload.users
      }
    case actions.addUser.type:
    case actions.editUser.type:
      return {
        ...state,
        saving: true,
        errors: null
      }
    case actions.addUserFailure.type:
    case actions.editUserFailure.type:
    case actions.domainAccessFailure.type:
      return {
        ...state,
        saving: false,
        errors: payload.errors
      }
    case actions.addUserSuccess.type:
    case actions.editUserSuccess.type:
    case actions.domainAccessSuccess.type:
      return {
        ...state,
        saving: false,
        modalOpen: false,
        selection: [],
        errors: null
      }
    case actions.toogleModal.type:
      return {
        ...state,
        modalOpen: !state.modalOpen
      }
    case accountActions.getAccountDataFailure.type:
      return initialState
    default:
      return state
  }
}

export default usersReducer
